// The credentialed cookie-sync endpoint can fail CORS and must not block Studio login.
export const AUTH_COOKIE_SYNC_ENABLED = false;

export const AUTH_COOKIE_SYNC_CONFIG = {
  dev: AUTH_COOKIE_SYNC_ENABLED,
  master: AUTH_COOKIE_SYNC_ENABLED,
  local: false,
};
